<template>
  <div class="iDalgo-Result-Me">
    <i-dalgo-stats />
    <i-dalgo-section-min
      v-for="(section, key) in players"
      :section="section"
      :active="true"
      :key="`section-${key}`" />
    <div class="iDalgo-Result-Me__Action">
      <i-dalgo-button
        v-if="env !== 'sharedLink'"
        @click="handleRestart">
        {{ $t('CTA.restart') }}
      </i-dalgo-button>
      <i-dalgo-button
        v-else
        @click="handleRestart">
        {{ $t('CTA.start') }}
      </i-dalgo-button>

      <social-sharing
        :url="getUrl"
        inline-template>
        <div class="iDalgo-Result-Me__Action__Social">
          <network network="facebook">
            <svgicon name="facebook" :original="true"></svgicon>
          </network>
          <network network="twitter">
            <svgicon name="twitter" :original="true"></svgicon>
          </network>
        </div>
      </social-sharing>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import iDalgoSectionMin from '@/components/iDalgo-Section-Min'
import iDalgoButton from '@/components/iDalgo-Button'
import iDalgoStats from '@/components/iDalgo-Stats'
import '@/components/icons'
import { isMobile } from '@/services/tools'
import { scrollTo } from '@/services/iframe'

export default {
  name: 'iDalgo-Result-Me',
  components: {
    iDalgoSectionMin,
    iDalgoStats,
    iDalgoButton
  },
  computed: {
    ...mapGetters({
      templateId: 'results/getTemplateId',
      players: 'results/getUserPlayers',
      env: 'app/getEnv',
      rootUrl: 'app/getRootUrl'
    }),
    isRealMobile () {
      return isMobile()
    },
    getUrl () {
      if (this.rootUrl === '') {
        return document.location.href
      }
      let uri = this.rootUrl
      uri = uri.split('playerListId')
      if (uri.length > 1) {
        uri = `${uri[0]}playerListId=${this.$route.params.id}`
      } else {
        uri = `${uri[0]}&playerListId=${this.$route.params.id}`
      }
      return uri
    }
  },
  methods: {
    handleRestart () {
      this.$store.commit('app/ENV_UPDATED', 'newListFromResult')
      this.$router.push({ name: 'steps', params: { id: this.templateId, step: 1 } })
    }
  },
  data () {
    return {}
  },
  mounted () {
    this.$store.dispatch('results/getData', this.$route.params.id).then(() => {
      this.$store.commit('app/LOADING_UPDATED', false)
    })
    if (this.env === 'sharedLink') {
      setTimeout(() => {
        scrollTo(this.$root.$el.offsetTop - this.$root.$el.clientTop, 600)
      }, 1000)
    } else if (this.env === 'showResult') {
      this.$store.commit('app/ENV_UPDATED', 'result')
      scrollTo(this.$root.$el.offsetTop - this.$root.$el.clientTop, 10)
    }
  }
}
</script>

<style lang="scss">
.iDalgo-Result-Me {
  font-family: "source_sans_proregular", sans-serif;

  &__Action {
    padding: 60px 88px;
    display: flex;

    &__Button {
      background: $color1;
      padding: 6px 30px;
      font-size: 19px;
      color: #fff;
      font-weight: bold;
      text-decoration: none;
      border-radius: 2px;
    }

    &__Social {
      display: flex;
      margin-left: auto;
      svg {
        width: 35px;
        height: 35px;
        margin-left: 8px;
        cursor: pointer;
      }
    }
  }

  @media (max-width: 640px) {
    &__Action {
      flex-flow: column;
      margin-top: 30px;
      padding: 16px;
      align-items: center;

      &__Button {
        padding: 14px 80px;
      }
      &__Social {
        margin: 30px 0 0 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/iDalgo-Result-Me.vue